import { render, staticRenderFns } from "./kesenkisi.vue?vue&type=template&id=ab920f6a"
import script from "./kesenkisi.vue?vue&type=script&lang=js"
export * from "./kesenkisi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports